import React from "react";
import { Button, Result } from "antd";
import { Link, useRouteError } from "react-router-dom";
import { routes } from "src/data/routes";

const ErrorComponent: React.FC = () => {
  const error = useRouteError();
  console.error(error);
  return (
    <Result
      status="500"
      title="500"
      subTitle={<>{error}</>}
      extra={
        <Link to={routes.INVESTMENTS}>
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
};

export default ErrorComponent;
